import { useCallback, useEffect, useRef } from 'react';

const useThrottle = (fn: (any) => void, delay: number, dep?: any[], waitingCb?: () => void) => {
  const { current } = useRef({ fn, timer: null, waitingCb });
  useEffect(
    function () {
      current.fn = fn;
      current.waitingCb = waitingCb;
    },
    [fn]
  );

  return useCallback(function f(...args) {
    if (!current.timer) {
      current.timer = setTimeout(() => {
        delete current.timer;
      }, delay);
      current.fn.call(this, ...args);
    } else {
      // 截流等待中的回掉
      current?.waitingCb?.call(this, ...args);
    }
  }, dep);
};

export default useThrottle;
